<script setup lang="ts"></script>
<template>
  <div>
    <div class="healt-check-container min-h-[86vh]">
      <slot />
    </div>
  </div>
</template>

<style scoped lang="scss">
header {
  padding: 0.5rem;
}

.healt-check-container {
  padding: 2rem 3rem;
}
</style>
